import { createAsyncThunk } from "@reduxjs/toolkit";
import bandsService from "../../../api/services/bands";

// Get my products (Basic 2 bands only)
export const getMyProducts = createAsyncThunk(
  "bandProducts/get-my-products",
  async (params) => {
    return await bandsService.getMyProducts(params);
  }
);

// Create product (Basic 2 bands only)
export const createMyProduct = createAsyncThunk(
  "bandProducts/create-my-product",
  async (formData) => {
    return await bandsService.createMyProduct(formData);
  }
);

// Update product (Basic 2 bands only)
export const updateMyProduct = createAsyncThunk(
  "bandProducts/update-my-product",
  async ({ id, requestData }) => {
    return await bandsService.updateMyProduct({ id, requestData });
  }
);

// Delete product (Basic 2 bands only)
export const deleteMyProduct = createAsyncThunk(
  "bandProducts/delete-my-product",
  async (id) => {
    return await bandsService.deleteMyProduct(id);
  }
);